module.exports = __webpack_public_path__ + "static/media/na.272478b8.png";